import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { TaskExcludedIds } from '../types';

type SaveIdsParams = Pick<TaskExcludedIds, 'ids' | 'task' | 'noExclusionNecessary' | 'project'>;

export const taskExcludedIdsMutations = getMutations({
  saveTaskExcludedIds: {
    action: async (excludedIds: SaveIdsParams): Promise<TaskExcludedIds> => {
      return executeApiCall<TaskExcludedIds>({
        path: '/projects/tasks/excluded-ids',

        method: 'post',

        payload: excludedIds,
      });
    },

    invalidateOnSuccess: ['projects.taskExcludedIds'],

    messages: {
      error: (t) => ({
        title: t('error-while-saving'),
        description: t('try-again-in-a-few-moments')!,
      }),

      success: (t) => ({
        title: t('exclusion-data-saved'),
        description: t('task-is-now-free-to-be-marked-as-completed-when-the-time-comes')!,
      }),
    },
  },
});
